<div class="snackbar-content">
    <h3 class="snackbar-title">{{ data.title }}</h3>
    <p class="snackbar-message" [innerHTML]="data.messages"></p>
  </div>
